import React, { useEffect, useState } from 'react'
import MainProfile from './main/MainProfile'
import ProfileModal from './main/modal'
import AddComponent from './main/AddComponent'
import IconWhite from '../../../assets/svgs/IconWhite'
import style from './main/MainProfile.module.css' // keep existing inner styles
import Profiles from './main/Profiles'
import Suggestions from './main/Suggestions'
import QuickChat from './main/QuickChat'
import useWindowWidth from '../../../hooks/useWindowWidth'
import ExpandIcon from '../../../assets/svgs/Expand'
import { useProfileContext } from '../../../contexts/ProfileContext'

// NEW: layout-specific CSS for this page only
import layout from './ProfileTab.module.css'

const ProfileTab = () => {
  const [modalTitle, setModalTitle] = useState('')
  const [selectedId, setSelectedId] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [openSideModal, setOpenSideModal] = useState(false)
  const [create, setCreate] = useState(false)
  const owner = true
  const [editMode, setEditMode] = useState(false)

  const innerWidth = useWindowWidth()

  const { userProfile, setUserProfile, fetchProfile, loading } =
    useProfileContext()

  useEffect(() => {
    fetchProfile()
  }, [fetchProfile])

  if (userProfile === null) {
    return (
      <div className={style.loading}>
        <IconWhite color={'#432c5b'} width={100} stroke={0.5} />
      </div>
    )
  }

  const toggleModal = (value, item, create) => {
    setOpenModal(!openModal)
    setModalTitle(value)
    setSelectedId(item)
    if (create !== undefined) {
      setCreate(true)
    }
  }
  const toggleSideModal = () => {
    setOpenSideModal(!openSideModal)
  }

  const editModelToggle = () => {
    setEditMode((prev) => !prev)
  }

  if (loading) return <p>Loading profile...</p>
  if (!userProfile) return <p>No profile data available.</p>

  return (
    <>
      {/* Use a page-specific grid so we don't touch .mainDashboard */}
      <div className={`${layout.profileDashboard} ${editMode ? layout.fullWidth : ''}`}>
        {/* LEFT 20% */}
        {!editMode && (
          <aside className={layout.leftCol}>
            {owner && (
              <>
                <AddComponent
                  userProfile={userProfile}
                  toggleModal={toggleModal}
                  openModal={openModal}
                  owner={owner}
                />
              </>
            )}
          </aside>
        )}

        {/* CENTER 60% */}
        <main className={layout.centerCol}>
          <MainProfile
            userProfile={userProfile}
            toggleModal={toggleModal}
            openModal={openModal}
            owner={owner}
            editMode={editMode}
            editModelToggle={editModelToggle}
          />

          <ProfileModal
            toggleModal={toggleModal}
            openModal={openModal}
            modalTitle={modalTitle}
            userProfile={userProfile}
            setUserProfile={setUserProfile}
            selectedId={selectedId}
            create={create}
          />
        </main>

        {/* RIGHT 20% */}
        {!editMode && (
          <aside className={layout.rightCol}>
            {owner && (
              <Suggestions
                toggleModal={toggleModal}
                openModal={openModal}
                modalTitle={modalTitle}
                userProfile={userProfile}
                selectedId={selectedId}
                create={create}
              />
            )}
          </aside>
        )}
      </div>

      {/* Mobile helpers remain */}
      {innerWidth < 768 && owner && (
        <div className={style.expandMenu} onClick={toggleSideModal}>
          <ExpandIcon />
        </div>
      )}
      {innerWidth < 768 && owner && openSideModal && (
        <div className={style.sideModal}>
          <Profiles
            userProfile={userProfile}
            toggleModal={toggleModal}
            openModal={openModal}
            owner={owner}
          />
          <AddComponent
            userProfile={userProfile}
            toggleModal={toggleModal}
            openModal={openModal}
            owner={owner}
          />
          {innerWidth < 768 && owner && (
            <div className={style.expandMenuBack} onClick={toggleSideModal}>
              <ExpandIcon />
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default ProfileTab


